import ListaPresencaReport from 'entity/Inscricao/Relatorios/ListaPresencaReport'
import Inscricao from 'entity/Inscricao'
import _ from 'lodash'
import { exportToExcelList } from 'OkReport/OkExcelExport'

export const imprimirListaPresenca = (inscricoes, rodada) => {
    const sortArrayAlphabetically = (originalArray) => {
        const sortedArray = [...originalArray].sort((a, b) => {
            // const nomeA = a.empresa.nomeEmpresaCracha.trim().toLowerCase()
            // const nomeB = b.empresa.nomeEmpresaCracha.trim().toLowerCase()
            const nomeA = a.empresa.funcionarios.nomeCracha
                ? a.empresa.funcionarios.nomeCracha.trim().toLowerCase()
                : a.empresa.funcionarios.nomeParticipante.trim().toLowerCase()
            const nomeB = b.empresa.funcionarios.nomeCracha
                ? b.empresa.funcionarios.nomeCracha.trim().toLowerCase()
                : b.empresa.funcionarios.nomeParticipante.trim().toLowerCase()

            if (nomeA < nomeB) return -1
            if (nomeA > nomeB) return 1
            return 0
        })

        return sortedArray
    }
    const addLeadingZero = (number) => (number < 10 ? `0${number}` : number)

    const dateObj = new Date(rodada.dataInicio)
    const dateToString = `${rodada.local} - ${addLeadingZero(dateObj.getDate())}/${addLeadingZero(dateObj.getMonth() + 1)}/${dateObj.getFullYear()} - ${addLeadingZero(dateObj.getHours())}:${addLeadingZero(dateObj.getMinutes())}`
    // console.log("lista em ordem alfabética", sortArrayAlphabetically(
    //     inscricoes.filter(i => i.status === 'INSCRITO'))
    //     .map(insc => {
    //         if (insc.empresa.funcionarios.nomeCracha) {
    //             return insc.empresa.funcionarios.nomeCracha.trim().toLowerCase()
    //         } else {
    //             return insc.empresa.funcionarios.nomeParticipante.trim().toLowerCase()
    //         }
    //     })
    // )

    new ListaPresencaReport({
        inscricoes: sortArrayAlphabetically(inscricoes.filter(i => i.status === 'INSCRITO'))
    }).generate({
        textoCabecalho1: rodada.nome,
        textoCabecalho2: dateToString,
        pageOrientation: 'landscape'
    })
}

const arrayToStringJoin = (list, path, divider) => {
    let auxList = []

    for (let j = 0; j < list?.length; j++) {
        auxList.push(_.get(list[j], path))
    }
    auxList = auxList.join(divider)
    return auxList
}

export const produtosSugeridosCSV = (list, rodada) => {
    let auxInscricoes = list
    for (let i = 0; i < auxInscricoes?.length; i++) {
        if (typeof auxInscricoes[i].outrosProdutos === "object") {
            auxInscricoes[i]["outrosProdutosStr"] = arrayToStringJoin(
                auxInscricoes[i].outrosProdutos,
                "description",
                " - "
            )
        } else if (typeof auxInscricoes[i].outrosProdutos === "string") {
            auxInscricoes[i]["outrosProdutosStr"] = auxInscricoes[i].outrosProdutos
        }
    }

    auxInscricoes = auxInscricoes.filter(insc => insc.outrosProdutosStr)

    // exportarCSV(auxInscricoes, Inscricao.csvColumnsProdutosSugeridos)
    exportToExcelList(auxInscricoes, Inscricao.csvColumnsProdutosSugeridos, {
        nomeArquivo: "Exportação de Produtos Sugeridos - " + rodada.nome,

    })
}

export const inscricoesCSV = (list, rodada) => {
    let auxInscricoes = list
    for (let i = 0; i < auxInscricoes?.length; i++) {
        auxInscricoes[i]["produtosVendaStr"] = arrayToStringJoin(
            auxInscricoes[i].empresa.produtosVenda,
            "produto.nome",
            " - "
        )
        auxInscricoes[i]["produtosCompraStr"] = arrayToStringJoin(
            auxInscricoes[i].empresa.produtosCompra,
            "produto.nome",
            " - "
        )

        if (typeof auxInscricoes[i].outrosProdutos === "object") {
            auxInscricoes[i]["outrosProdutosStr"] = arrayToStringJoin(
                auxInscricoes[i].outrosProdutos,
                "description",
                " - "
            )
        } else if (typeof auxInscricoes[i].outrosProdutos === "string") {
            auxInscricoes[i]["outrosProdutosStr"] = auxInscricoes[i].outrosProdutos
        }
    }

    // exportarCSV(auxInscricoes, Inscricao.csvColumns)// inscricoesColunasCSV)
    let colunas = Inscricao.csvColumns
    if (rodada.questoesSecundarias) {
        rodada.questoesSecundarias.forEach(q => {
            if (q.type !== "instrucao") {
                colunas.push({ labelCol: "QUESTIONÁRIO - " + q.questao, getValue: "respostaQuestionario." + (q.key || q.questao) })
            }
        })



    }

    let autoFilter = {
        from: 'A1',
        to: 'AF1',
    };
    console.log('autoFilter', autoFilter)
    exportToExcelList(auxInscricoes, colunas, {
        nomeArquivo: "Exportação de Participantes - " + rodada.nome,
        autoFilter,
        views: [{ state: 'frozen', ySplit: 1 }],
        configHeader: {
            // maxWidthColumn: 60

        }
    })
}

export const inscricoesCSVSimplificada = (list, rodada) => {
    // Colunas simplificadas
    const colunasSimplificadas = [
        { labelCol: "DATA DE CADASTRO", getValue: "dataFirstChange" },
        { labelCol: "STATUS NO EVENTO", getValue: "statusEvento" },
        { labelCol: "TIPO DE INSCRIÇÃO", getValue: "tipo" },
        { labelCol: "STATUS DA INSCRIÇÃO", getValue: "status" },
        { labelCol: "NOME DA EMPRESA", getValue: "empresa.nomeFantasia" },
        { labelCol: "RAZÃO SOCIAL", getValue: "empresa.razaoSocial" },
        { labelCol: "CNPJ/CPF DA EMPRESA", getValue: "empresa.cnpj" },
        { labelCol: "COLABORADOR", getValue: "empresa.funcionarios.nomeParticipante" },
        { labelCol: "SEXO", getValue: "empresa.funcionarios.sexo" },
        { labelCol: "CPF DO COLABORADOR", getValue: "empresa.funcionarios.cpf" },
        { labelCol: "CELULAR DO COLABORADOR", getValue: "empresa.funcionarios.celular" },
        { labelCol: "CELULAR DA EMPRESA", getValue: "empresa.celular" },
        { labelCol: "TELEFONE COMERCIAL DA EMPRESA", getValue: "empresa.telComercial" },
        { labelCol: "TELEFONE COMERCIAL DO COLABORADOR", getValue: "empresa.funcionarios.telComercial" },
        { labelCol: "EMAIL", getValue: "empresa.funcionarios.email" },
        { labelCol: "ENDEREÇO", getValue: "empresa.endereco" },
        { labelCol: "MUNICÍPIO", getValue: "municipio" },
        { labelCol: "RODADA", getValue: "rodada.nome" }
    ];

    let autoFilter = {
        from: 'A1',
        to: 'R1', // Ajustado para 18 colunas (A-R)
    };

    exportToExcelList(list, colunasSimplificadas, {
        nomeArquivo: "Exportação Simplificada de Participantes - " + rodada.nome,
        autoFilter,
        views: [{ state: 'frozen', ySplit: 1 }],
        configHeader: {
            // maxWidthColumn: 60
        }
    })
}

const exportarCSV1 = (list, columns) => {

    let conf = columns

    if (list.length) {
        createCSVContent(list, conf)
    } else {
        console.log("Lista vazia p/ criação de CSV")
    }

}

const createCSVContent = (list, conf) => {
    let strCsv = '';
    let separator = ';'
    conf.forEach(c => {
        strCsv += c.labelCol + separator
    })
    strCsv += '\n'

    list.forEach(l => {
        conf.forEach(c => {
            let v = ""
            if (_.isString(c.getValue)) {
                v = _.get(l, c.getValue)
                if (v) {
                    v = '"' + v + '"'
                }
            } else {
                v = c.getValue(l)
            }
            if (!v) {
                v = ''
            }
            strCsv += v + separator
        })
        strCsv += '\n'
    })

    gerarArquivo(strCsv, `ExportarCSVRodada.csv`)
}

const gerarArquivo = (texto, nome) => {

    let fileBlob = new Blob(["\ufeff", texto])
    if (window.cordova) {
        document.addEventListener("deviceready", function () {
            var storageLocation = ""
            console.log('window.cordova', window.cordova)
            storageLocation = window.cordova.file.dataDirectory

            var folderPath = storageLocation
            console.log('folderPath', folderPath)
            console.log('nome', nome)
            window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                    console.log("Access to the directory granted succesfully", dir)
                    dir.getFile(
                        nome,
                        {
                            create: true
                        },
                        function (file) {
                            console.log('file', file)
                            file.createWriter(
                                function (fileWriter) {
                                    fileWriter.write(fileBlob)

                                    fileWriter.onwriteend = function () {
                                        var url = file.toURL()
                                        console.log('url', url)
                                        window.cordova.plugins.fileOpener2.open(folderPath + nome, "text/plain", {
                                            error: function error(err) {
                                                console.error(err)
                                                alert("Unable to download3")
                                            },
                                            success: function success() {
                                                console.log("success with opening the file")
                                            }
                                        })
                                    }

                                    fileWriter.onerror = function (err) {
                                        alert("Unable to download2")
                                        console.error(err)
                                    }
                                },
                                function (err) {
                                    // failed
                                    alert("Unable to download")
                                    console.error('err', err)
                                }
                            )
                        },
                        function (err) {
                            alert("Unable to download")
                            console.error(err)
                        }
                    )
                },
                function (err) {
                    alert("Unable to download")
                    console.error(err)
                }
            )
        })
    } else {

        var element = document.createElement("a")

        // let file = new Blob([texto], { type: "text/plain;charset=utf-8" })
        element.href = URL.createObjectURL(fileBlob)
        element.download = nome
        element.click()
    }
}